import script from "./performanceCriteria.vue?vue&type=script&setup=true&lang=js"
export * from "./performanceCriteria.vue?vue&type=script&setup=true&lang=js"

import "./performanceCriteria.vue?vue&type=style&index=0&id=9402b888&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9402b888"]])

export default __exports__